import { render, staticRenderFns } from "./SidebarMenuSubitem.vue?vue&type=template&id=652662ff&scoped=true"
import script from "./SidebarMenuSubitem.vue?vue&type=script&lang=js"
export * from "./SidebarMenuSubitem.vue?vue&type=script&lang=js"
import style0 from "./SidebarMenuSubitem.vue?vue&type=style&index=0&id=652662ff&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "652662ff",
  null
  
)

export default component.exports